import { autoinject } from "aurelia-dependency-injection";
import { ApproveEmailsRequest, ApproveEmailsResponse } from "../../models/emails/email.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject
export class EmailService {

    constructor(private requestClient: RequestClientService) { }

    public resendEmail(emailHistoryId: number): Promise<boolean> {
        return this.requestClient.post<boolean>("email/resendEmail", { emailHistoryId }, {});
    }

    public rejectEmail(emailHistoryId: number): Promise<void> {
        return this.requestClient.post("email/rejectEmail", { emailHistoryId }, {});
    }

    public approveEmails(request: ApproveEmailsRequest): Promise<ApproveEmailsResponse> {
        return this.requestClient.post<ApproveEmailsResponse>("email/approveEmails", {}, request);
    }

    public getEmail(emailHistoryId: number): Promise<any> {
        return this.requestClient.get<any>("email/getEmail", { emailHistoryId: emailHistoryId });
    }

    public saveEmail(request: any): Promise<void> {
        return this.requestClient.post("email/saveEmail", {}, request);
    }

    public sendTestEmail(request: any): Promise<boolean> {
        return this.requestClient.post<boolean>("email/sendTestEmail", {}, request);
    }
}
